import { render, staticRenderFns } from "./BannerTable.vue?vue&type=template&id=2d90ead7&scoped=true"
import script from "./BannerTable.vue?vue&type=script&lang=js"
export * from "./BannerTable.vue?vue&type=script&lang=js"
import style0 from "./BannerTable.vue?vue&type=style&index=0&id=2d90ead7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90ead7",
  null
  
)

export default component.exports